import { getStylusClassName } from '@elfsight/widget-utils';
import { meta } from '../../meta';

export const getClassName = (fileName: string, component: string) =>
  getStylusClassName({ appAlias: meta.alias, fileName, component });
